<template>
  <div v-if="isOpen" class="modal-overlay" @click="close">
    <div :class="['modal-content-component']" :style="[{ width, height }, styleModal]" @click.stop>
      <slot></slot>
      <button class="close-button" @click="close">
        <i class="fa-solid fa-x"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    width: {
      type: String,
      default: '400px'
    },
    height: {
      type: String,
      default: 'auto'
    },
    styleModal: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      isOpen: this.modelValue,
    };
  },
  watch: {
    modelValue(newValue) {
      this.isOpen = newValue;
    },
  },
  methods: {
    close() {
      this.isOpen = false;
      this.$emit('update:modelValue', false);
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.modal-content-component {
  background: white;
  border-radius: 5px;
  position: relative;
  max-height: 90vh;
  max-width: 90%;
  z-index: 1000;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transform: translateY(0);
  opacity: 1;
  overflow-y: auto;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
}
</style>